module.exports = __webpack_public_path__ + "static/img/parameters.907ff17.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/parameters.png
// module id = 8cAh
// module chunks = 1